import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  createFailure8paxfkfa5dc7 as createFailure,
  Result3t1vadv16kmzk as Result,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString1h6jjoch8cjt8 as toString_0,
  newThrowablezl37abp36p5f as newThrowable,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  protoOf180f3jzyo7rfj as protoOf,
  isInterface3d6p8outrmvmk as isInterface,
  constructCallableReference23y65rf941mch as constructCallableReference,
  fromInt1lka3ktyu79a4 as fromInt,
  compare2uud5j30pw5xc as compare,
  numberToLong345n6tb1n1i71 as numberToLong,
  add85si75olwt6n as add,
  intercepted2ogpsikxxj4u0 as intercepted,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  Long2qws0ah9gnpki as Long,
  convertToIntofdoxh9bstof as convertToInt,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  captureStack1fzi4aczwc4hg as captureStack,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equalsLong28bsrfhwvd686 as equalsLong,
  get_ONEazvfdh9ju3d4 as get_ONE,
  replace3le3ie7l9k8aq as replace,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString_1,
  subtract16cg4lfi29fq9 as subtract,
  EmptyCoroutineContext_getInstance2wsqunjuleo79 as EmptyCoroutineContext_getInstance,
  Continuation1aa2oekvx7jm7 as Continuation,
  CancellationException3b36o9qz53rgr as CancellationException,
  Enum3alwj03lh1n41 as Enum,
  ArrayList3it5z8td81qkl as ArrayList,
  listOf1jh22dvmctj1r as listOf,
  StringBuildermazzzhj6kkai as StringBuilder,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  encodeToByteArray22651fhg4p67t as encodeToByteArray,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toByte4i43936u611k as toByte,
  decodeToString1x4faah2liw2p as decodeToString,
  setOf45ia9pnfhe90 as setOf,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Buffergs925ekssbch as Buffer,
  indexOf29nspdgx2e3ap as indexOf,
  IOException1wyutdmfe71nu as IOException,
  EOFExceptionh831u25jcq9n as EOFException,
  readByteString2hnsbql6t4ads as readByteString,
  readString3v6duspiz33tv as readString,
  readString2nvggcfaijfhd as readString_0,
  readByteArray1fhzfwi2j014k as readByteArray,
  writeString33ca4btrgctw7 as writeString,
  readByteArray1ri21h2rciakw as readByteArray_0,
} from './kotlinx-io-kotlinx-io-core.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  launch1c91vkjzdi9sd as launch,
  startCoroutineCancellable18shtfwdieib as startCoroutineCancellable,
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
  cancel1xim2hrvjmwpn as cancel,
  CopyableThrowable1mvc99jcyvivf as CopyableThrowable,
  Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance,
} from './kotlinx-coroutines-core.mjs';
import { decodeToString2ede220pr5xir as decodeToString_0 } from './kotlinx-io-kotlinx-io-bytestring.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.l75_1 = new Closed(null);
    var tmp = this;
    // Inline function 'kotlin.Companion.success' call
    tmp.m75_1 = _Result___init__impl__xyqfz8(Unit_instance);
  }
}
class Empty {
  toString() {
    return 'Empty';
  }
  hashCode() {
    return -231472095;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Empty))
      return false;
    return true;
  }
}
class Closed {
  constructor(cause) {
    this.n75_1 = cause;
  }
  toString() {
    return 'Closed(cause=' + toString(this.n75_1) + ')';
  }
  hashCode() {
    return this.n75_1 == null ? 0 : hashCode(this.n75_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Closed))
      return false;
    if (!equals(this.n75_1, other.n75_1))
      return false;
    return true;
  }
}
class Task {}
function resume() {
  return this.p75().qd(Companion_getInstance().m75_1);
}
function resume_0(throwable) {
  var tmp = this.p75();
  var tmp_0;
  if (throwable == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(throwable));
    tmp_0 = new Result(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp.qd(tmp1_elvis_lhs == null ? Companion_getInstance().m75_1 : tmp1_elvis_lhs.zw_1);
}
class Read {
  constructor(continuation) {
    this.t75_1 = continuation;
    this.u75_1 = null;
    if (get_DEVELOPMENT_MODE()) {
      var tmp = this;
      // Inline function 'kotlin.also' call
      var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.t75_1), 16));
      stackTraceToString(this_0);
      tmp.u75_1 = this_0;
    }
  }
  p75() {
    return this.t75_1;
  }
  o75() {
    return this.u75_1;
  }
  q75() {
    return 'read';
  }
}
class Write {
  constructor(continuation) {
    this.v75_1 = continuation;
    this.w75_1 = null;
    if (get_DEVELOPMENT_MODE()) {
      var tmp = this;
      // Inline function 'kotlin.also' call
      var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.v75_1), 16));
      stackTraceToString(this_0);
      tmp.w75_1 = this_0;
    }
  }
  p75() {
    return this.v75_1;
  }
  o75() {
    return this.w75_1;
  }
  q75() {
    return 'write';
  }
}
class ByteReadChannel {}
function awaitContent$default(min, $completion, $super) {
  min = min === VOID ? 1 : min;
  return $super === VOID ? this.y76(min, $completion) : $super.y76.call(this, min, $completion);
}
class ByteWriteChannel {}
function get_autoFlush() {
  return false;
}
class ByteChannel {
  constructor(autoFlush) {
    autoFlush = autoFlush === VOID ? false : autoFlush;
    this.x75_1 = autoFlush;
    this.y75_1 = new Buffer();
    this.z75_1 = 0;
    this.a76_1 = new Object();
    this.b76_1 = atomic$ref$1(Empty_instance);
    this.c76_1 = new Buffer();
    this.d76_1 = new Buffer();
    this.e76_1 = atomic$ref$1(null);
  }
  p76() {
    return this.x75_1;
  }
  q76() {
    var tmp0_safe_receiver = this.e76_1.kotlinx$atomicfu$value;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s76(ClosedReadChannelException$_init_$ref_ix0089());
    }
    if (this.c76_1.g72()) {
      moveFlushToReadBuffer(this);
    }
    return this.c76_1;
  }
  t76() {
    if (this.u76()) {
      var tmp0_safe_receiver = this.e76_1.kotlinx$atomicfu$value;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp = tmp0_safe_receiver.s76(ClosedWriteChannelException$_init_$ref_ef15ty());
      }
      if (tmp == null)
        throw ClosedWriteChannelException.o76();
    }
    return this.d76_1;
  }
  v76() {
    var tmp0_safe_receiver = this.e76_1.kotlinx$atomicfu$value;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w76();
  }
  u76() {
    return !(this.e76_1.kotlinx$atomicfu$value == null);
  }
  x76() {
    return !(this.v76() == null) || (this.u76() && this.z75_1 === 0 && this.c76_1.g72());
  }
  *y76(min, $completion) {
    rethrowCloseCauseIfNeeded(this);
    if (compare(this.c76_1.s2(), fromInt(min)) >= 0)
      return true;
    // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
    var this_0 = this;
    $l$loop: while (compare(add(numberToLong(this.z75_1), this.c76_1.s2()), fromInt(min)) < 0 && this.e76_1.kotlinx$atomicfu$value == null) {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      (yield () => {
        var uCont = $completion;
        var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
        cancellable.u1p();
        var tmp0 = this_0;
        var tmp2 = new Read(cancellable);
        $l$block_0: {
          // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
          var previous = tmp0.b76_1.kotlinx$atomicfu$value;
          if (!(previous instanceof Closed)) {
            if (!tmp0.b76_1.atomicfu$compareAndSet(previous, tmp2)) {
              tmp2.r75();
              break $l$block_0;
            }
          }
          if (previous instanceof Read) {
            previous.s75(ConcurrentIOException.d77(tmp2.q75(), previous.o75()));
          } else {
            if (isInterface(previous, Task)) {
              previous.r75();
            } else {
              if (previous instanceof Closed) {
                tmp2.s75(previous.n75_1);
                break $l$block_0;
              } else {
                if (!equals(previous, Empty_instance)) {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
          if (!(compare(add(numberToLong(this.z75_1), this.c76_1.s2()), fromInt(min)) < 0 && this.e76_1.kotlinx$atomicfu$value == null)) {
            // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
            var current = tmp0.b76_1.kotlinx$atomicfu$value;
            var tmp;
            if (current instanceof Read) {
              tmp = tmp0.b76_1.atomicfu$compareAndSet(current, Empty_instance);
            } else {
              tmp = false;
            }
            if (tmp) {
              current.r75();
            }
          }
        }
        return cancellable.v1p();
      });
    }
    if (compare(this.c76_1.s2(), new Long(1048576, 0)) < 0) {
      moveFlushToReadBuffer(this);
    }
    return compare(this.c76_1.s2(), fromInt(min)) >= 0;
  }
  *f77($completion) {
    rethrowCloseCauseIfNeeded(this);
    this.g77();
    if (this.z75_1 < 1048576)
      return Unit_instance;
    // Inline function 'io.ktor.utils.io.ByteChannel.sleepWhile' call
    var this_0 = this;
    $l$loop: while (this.z75_1 >= 1048576 && this.e76_1.kotlinx$atomicfu$value == null) {
      // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
      // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
      (yield () => {
        var uCont = $completion;
        var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
        cancellable.u1p();
        var tmp0 = this_0;
        var tmp2 = new Write(cancellable);
        $l$block_0: {
          // Inline function 'io.ktor.utils.io.ByteChannel.trySuspend' call
          var previous = tmp0.b76_1.kotlinx$atomicfu$value;
          if (!(previous instanceof Closed)) {
            if (!tmp0.b76_1.atomicfu$compareAndSet(previous, tmp2)) {
              tmp2.r75();
              break $l$block_0;
            }
          }
          if (previous instanceof Write) {
            previous.s75(ConcurrentIOException.d77(tmp2.q75(), previous.o75()));
          } else {
            if (isInterface(previous, Task)) {
              previous.r75();
            } else {
              if (previous instanceof Closed) {
                tmp2.s75(previous.n75_1);
                break $l$block_0;
              } else {
                if (!equals(previous, Empty_instance)) {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
          if (!(this.z75_1 >= 1048576 && this.e76_1.kotlinx$atomicfu$value == null)) {
            // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
            var current = tmp0.b76_1.kotlinx$atomicfu$value;
            var tmp;
            if (current instanceof Write) {
              tmp = tmp0.b76_1.atomicfu$compareAndSet(current, Empty_instance);
            } else {
              tmp = false;
            }
            if (tmp) {
              current.r75();
            }
          }
        }
        return cancellable.v1p();
      });
    }
    return Unit_instance;
  }
  g77() {
    if (this.d76_1.g72())
      return Unit_instance;
    // Inline function 'io.ktor.utils.io.locks.synchronized' call
    this.a76_1;
    var count = convertToInt(this.d76_1.s2());
    this.y75_1.x73(this.d76_1);
    this.z75_1 = this.z75_1 + count | 0;
    // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
    var current = this.b76_1.kotlinx$atomicfu$value;
    var tmp;
    if (current instanceof Read) {
      tmp = this.b76_1.atomicfu$compareAndSet(current, Empty_instance);
    } else {
      tmp = false;
    }
    if (tmp) {
      current.r75();
    }
  }
  f7() {
    this.g77();
    if (!this.e76_1.atomicfu$compareAndSet(null, get_CLOSED()))
      return Unit_instance;
    closeSlot(this, null);
  }
  *h77($completion) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      yield* this.f77($completion);
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    if (!this.e76_1.atomicfu$compareAndSet(null, get_CLOSED()))
      return Unit_instance;
    closeSlot(this, null);
    return Unit_instance;
  }
  i77(cause) {
    if (!(this.e76_1.kotlinx$atomicfu$value == null))
      return Unit_instance;
    var closedToken = new CloseToken(cause);
    this.e76_1.atomicfu$compareAndSet(null, closedToken);
    var wrappedCause = closedToken.w76();
    closeSlot(this, wrappedCause);
  }
  toString() {
    return 'ByteChannel[' + hashCode(this) + ']';
  }
}
class ConcurrentIOException extends IllegalStateException {
  constructor(taskName, cause) {
    return new.target.d77(taskName, cause);
  }
  static d77(taskName, cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.q('Concurrent ' + taskName + ' attempts', cause);
    captureStack($this, $this.c77_1);
    return $this;
  }
}
class ByteChannelScanner {
  constructor(channel, matchString, writeChannel, limit) {
    limit = limit === VOID ? new Long(-1, 2147483647) : limit;
    this.j77_1 = channel;
    this.k77_1 = matchString;
    this.l77_1 = writeChannel;
    this.m77_1 = limit;
    // Inline function 'kotlin.require' call
    if (!(this.k77_1.s2() > 0)) {
      var message = 'Empty match string not permitted for scanning';
      throw IllegalArgumentException.h2(toString_1(message));
    }
    this.n77_1 = this.j77_1.q76();
    this.o77_1 = buildPartialMatchTable(this);
    this.p77_1 = new Buffer();
    this.q77_1 = new Long(0, 0);
    this.r77_1 = 0;
  }
  *s77(ignoreMissing, $completion) {
    this.q77_1 = new Long(0, 0);
    while (!this.n77_1.g72() || (yield* this.j77_1.e77(VOID, $completion))) {
      yield* /*#__NOINLINE__*/advanceToNextPotentialMatch(this, $completion);
      if (yield* /*#__NOINLINE__*/checkFullMatch(this, $completion)) {
        return this.q77_1;
      }
    }
    if (!ignoreMissing) {
      throw IOException.i75('Expected "' + toSingleLineString(this, this.k77_1) + '" but encountered end of input');
    }
    this.q77_1 = add(this.q77_1, this.p77_1.j73(this.l77_1.t76()));
    yield* this.l77_1.f77($completion);
    return this.q77_1;
  }
}
class ByteReadChannel$Companion$Empty$1 {
  constructor() {
    this.t77_1 = null;
    this.u77_1 = new Buffer();
  }
  v76() {
    return this.t77_1;
  }
  x76() {
    return true;
  }
  q76() {
    return this.u77_1;
  }
  *y76(min, $completion) {
    return false;
  }
  i77(cause) {
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    var tmp = this;
    tmp.v77_1 = new ByteReadChannel$Companion$Empty$1();
  }
}
class WriterJob {
  constructor(channel, job) {
    this.b78_1 = channel;
    this.c78_1 = job;
  }
  g1p() {
    return this.c78_1;
  }
}
class WriterScope {
  constructor(channel, coroutineContext) {
    this.d78_1 = channel;
    this.e78_1 = coroutineContext;
  }
  d1m() {
    return this.e78_1;
  }
}
class NO_CALLBACK$1 {
  constructor() {
    this.f78_1 = EmptyCoroutineContext_getInstance();
  }
  od() {
    return this.f78_1;
  }
  pd(result) {
    return Unit_instance;
  }
  qd(result) {
    return this.pd(result);
  }
}
class CloseToken {
  constructor(origin) {
    this.r76_1 = origin;
  }
  k78(wrap) {
    var tmp0_subject = this.r76_1;
    var tmp;
    if (tmp0_subject == null) {
      tmp = null;
    } else {
      if (isInterface(tmp0_subject, CopyableThrowable)) {
        tmp = this.r76_1.h1u();
      } else {
        if (tmp0_subject instanceof CancellationException) {
          tmp = CancellationException.p(this.r76_1.message, this.r76_1);
        } else {
          tmp = wrap(this.r76_1);
        }
      }
    }
    return tmp;
  }
  w76(wrap, $super) {
    var tmp;
    if (wrap === VOID) {
      tmp = ClosedByteChannelException$_init_$ref_yjp351();
    } else {
      tmp = wrap;
    }
    wrap = tmp;
    return $super === VOID ? this.k78(wrap) : $super.k78.call(this, wrap);
  }
  s76(wrap) {
    var tmp0_safe_receiver = this.k78(wrap);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
    return tmp;
  }
}
class CountedByteReadChannel {
  constructor(delegate) {
    this.l78_1 = delegate;
    this.m78_1 = new Buffer();
    this.n78_1 = new Long(0, 0);
    this.o78_1 = new Long(0, 0);
  }
  p78() {
    updateConsumed(this);
    return this.o78_1;
  }
  v76() {
    return this.l78_1.v76();
  }
  x76() {
    return this.m78_1.g72() && this.l78_1.x76();
  }
  q76() {
    transferFromDelegate(this);
    return this.m78_1;
  }
  *y76(min, $completion) {
    if (compare(this.q76().s2(), fromInt(min)) >= 0) {
      return true;
    }
    if (yield* this.l78_1.y76(min, $completion)) {
      transferFromDelegate(this);
      return true;
    }
    return false;
  }
  i77(cause) {
    this.l78_1.i77(cause);
    this.m78_1.f7();
  }
}
class ClosedByteChannelException extends IOException {
  constructor(cause) {
    return new.target.j78(cause);
  }
  static j78(cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.j75(cause == null ? null : cause.message, cause);
    captureStack($this, $this.i78_1);
    return $this;
  }
}
class ClosedReadChannelException extends ClosedByteChannelException {
  constructor(cause) {
    return new.target.j76(cause);
  }
  static j76(cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.j78(cause);
    captureStack($this, $this.i76_1);
    return $this;
  }
}
class ClosedWriteChannelException extends ClosedByteChannelException {
  constructor(cause) {
    return new.target.o76(cause);
  }
  static o76(cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.j78(cause);
    captureStack($this, $this.n76_1);
    return $this;
  }
}
class LineEnding extends Enum {}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    this.q78_1 = _LineEndingMode___init__impl__jo5bul(1);
    this.r78_1 = _LineEndingMode___init__impl__jo5bul(2);
    this.s78_1 = _LineEndingMode___init__impl__jo5bul(4);
    this.t78_1 = _LineEndingMode___init__impl__jo5bul(7);
    this.u78_1 = listOf([new LineEndingMode(this.q78_1), new LineEndingMode(this.r78_1), new LineEndingMode(this.s78_1)]);
  }
}
class LineEndingMode {
  constructor(mode) {
    Companion_getInstance_1();
    this.v78_1 = mode;
  }
  toString() {
    return LineEndingMode__toString_impl_j4h76r(this.v78_1);
  }
  hashCode() {
    return LineEndingMode__hashCode_impl_2mopm4(this.v78_1);
  }
  equals(other) {
    return LineEndingMode__equals_impl_qyr4nk(this.v78_1, other);
  }
}
class SourceByteReadChannel {
  constructor(source) {
    this.w78_1 = source;
    this.x78_1 = null;
  }
  v76() {
    var tmp0_safe_receiver = this.x78_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w76();
  }
  x76() {
    return this.w78_1.g72();
  }
  q76() {
    var tmp0_safe_receiver = this.v76();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
    return this.w78_1.f72();
  }
  *y76(min, $completion) {
    var tmp0_safe_receiver = this.v76();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
    return this.w78_1.i72(fromInt(min));
  }
  i77(cause) {
    if (!(this.x78_1 == null))
      return Unit_instance;
    this.w78_1.f7();
    var tmp = this;
    var tmp1_elvis_lhs = cause == null ? null : cause.message;
    tmp.x78_1 = new CloseToken(IOException.j75(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
  }
}
class MalformedInputException extends IOException {
  constructor(message) {
    return new.target.b79(message);
  }
  static b79(message) {
    var $this = this.i75(message);
    captureStack($this, $this.a79_1);
    return $this;
  }
}
class TooLongLineException extends MalformedInputException {
  constructor(message) {
    return new.target.a78(message);
  }
  static a78(message) {
    var $this = this.b79(message);
    captureStack($this, $this.z77_1);
    return $this;
  }
}
class ObjectPool {}
function close() {
  this.u1o();
}
class DefaultPool {
  constructor(capacity) {
    this.l79_1 = capacity;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.l79_1;
    tmp.m79_1 = Array(size);
    this.n79_1 = 0;
  }
  o79(instance) {
  }
  p79(instance) {
    return instance;
  }
  q79(instance) {
  }
  r79() {
    if (this.n79_1 === 0)
      return this.k79();
    this.n79_1 = this.n79_1 - 1 | 0;
    var idx = this.n79_1;
    var tmp = this.m79_1[idx];
    var instance = !(tmp == null) ? tmp : THROW_CCE();
    this.m79_1[idx] = null;
    return this.p79(instance);
  }
  s79(instance) {
    this.q79(instance);
    if (this.n79_1 === this.l79_1) {
      this.o79(instance);
    } else {
      var _unary__edvuaz = this.n79_1;
      this.n79_1 = _unary__edvuaz + 1 | 0;
      this.m79_1[_unary__edvuaz] = instance;
    }
  }
  u1o() {
    var inductionVariable = 0;
    var last = this.n79_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.m79_1[i];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.m79_1[i] = null;
        this.o79(instance);
      }
       while (inductionVariable < last);
    this.n79_1 = 0;
  }
}
class ByteArrayPool$1 extends DefaultPool {
  constructor() {
    super(128);
  }
  k79() {
    return new Int8Array(4096);
  }
}
class NoPoolImpl {
  s79(instance) {
    return Unit_instance;
  }
  u1o() {
    return Unit_instance;
  }
}
class Companion_2 {
  t79(name) {
    switch (name) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        return Charsets_getInstance().c79_1;
    }
    var tmp;
    var tmp_0;
    switch (name) {
      case 'ISO-8859-1':
      case 'iso-8859-1':
        tmp_0 = true;
        break;
      default:
        // Inline function 'kotlin.let' call

        var it = replace_0(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
        var tmp_1;
        if (it === 'iso-8859-1') {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_1 = it.toLowerCase() === 'iso-8859-1';
        }

        tmp_0 = tmp_1;
        break;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = name === 'latin1' || name === 'Latin1';
    }
    if (tmp) {
      return Charsets_getInstance().d79_1;
    }
    throw IllegalArgumentException.h2('Charset ' + name + ' is not supported');
  }
}
class Charset {
  constructor(_name) {
    this.e79_1 = _name;
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !(this.constructor == other.constructor))
      return false;
    if (!(other instanceof Charset))
      THROW_CCE();
    return this.e79_1 === other.e79_1;
  }
  hashCode() {
    return getStringHashCode(this.e79_1);
  }
  toString() {
    return this.e79_1;
  }
}
class Charsets {
  constructor() {
    Charsets_instance = this;
    this.c79_1 = new CharsetImpl('UTF-8');
    this.d79_1 = new CharsetImpl('ISO-8859-1');
  }
}
class CharsetDecoder {
  constructor(_charset) {
    this.u79_1 = _charset;
  }
}
class CharsetEncoder {
  constructor(_charset) {
    this.v79_1 = _charset;
  }
}
class CharsetImpl extends Charset {
  g79() {
    return new CharsetEncoderImpl(this);
  }
  f79() {
    return new CharsetDecoderImpl(this);
  }
}
class CharsetEncoderImpl extends CharsetEncoder {
  constructor(charset) {
    super(charset);
    this.z79_1 = charset;
  }
  toString() {
    return 'CharsetEncoderImpl(charset=' + this.z79_1.toString() + ')';
  }
  hashCode() {
    return this.z79_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetEncoderImpl))
      return false;
    if (!this.z79_1.equals(other.z79_1))
      return false;
    return true;
  }
}
class CharsetDecoderImpl extends CharsetDecoder {
  constructor(charset) {
    super(charset);
    this.b7a_1 = charset;
  }
  toString() {
    return 'CharsetDecoderImpl(charset=' + this.b7a_1.toString() + ')';
  }
  hashCode() {
    return this.b7a_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetDecoderImpl))
      return false;
    if (!this.b7a_1.equals(other.b7a_1))
      return false;
    return true;
  }
}
class toKtor$1 {
  constructor($this_toKtor) {
    this.c7a_1 = $this_toKtor;
  }
  w79(buffer) {
    return this.c7a_1.decode(buffer);
  }
}
class TextDecoderFallback {
  constructor(encoding, fatal) {
    this.d7a_1 = fatal;
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var requestedEncoding = toString_1(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.check' call
    if (!get_ENCODING_ALIASES().w2(requestedEncoding)) {
      var message = encoding + ' is not supported.';
      throw IllegalStateException.o(toString_1(message));
    }
  }
  w79(buffer) {
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
    var inductionVariable = 0;
    var last = bytes.length;
    if (inductionVariable < last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var byte = bytes[index];
        var point = toCodePoint(byte);
        if (point < 0) {
          // Inline function 'kotlin.check' call
          if (!!this.d7a_1) {
            var message = 'Invalid character: ' + point;
            throw IllegalStateException.o(toString_1(message));
          }
          writeFully_0(builder, get_REPLACEMENT());
          continue $l$loop;
        }
        if (point > 255) {
          builder.y73(toByte(point >> 8));
        }
        builder.y73(toByte(point & 255));
      }
       while (inductionVariable < last);
    return decodeToString(readByteArray_0(builder));
  }
}
//endregion
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
function moveFlushToReadBuffer($this) {
  // Inline function 'io.ktor.utils.io.locks.synchronized' call
  $this.a76_1;
  $this.y75_1.j73($this.c76_1);
  $this.z75_1 = 0;
  // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
  var current = $this.b76_1.kotlinx$atomicfu$value;
  var tmp;
  if (current instanceof Write) {
    tmp = $this.b76_1.atomicfu$compareAndSet(current, Empty_instance);
  } else {
    tmp = false;
  }
  if (tmp) {
    current.r75();
  }
}
function closeSlot($this, cause) {
  var closeContinuation = !(cause == null) ? new Closed(cause) : Companion_getInstance().l75_1;
  var continuation = $this.b76_1.atomicfu$getAndSet(closeContinuation);
  if (isInterface(continuation, Task)) {
    continuation.s75(cause);
  }
}
function ClosedReadChannelException$_init_$ref_ix0089() {
  return constructCallableReference((p0) => ClosedReadChannelException.j76(p0), 1, 0, 19, '<init>');
}
function ClosedWriteChannelException$_init_$ref_ef15ty() {
  return constructCallableReference((p0) => ClosedWriteChannelException.o76(p0), 1, 0, 20, '<init>');
}
function ByteReadChannel_0(content, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? content.length : length;
  // Inline function 'kotlin.also' call
  var this_0 = new Buffer();
  this_0.p73(content, offset, offset + length | 0);
  var source = this_0;
  return ByteReadChannel_1(source);
}
function ByteReadChannel_1(source) {
  return new SourceByteReadChannel(source);
}
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.k77_1.s2());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.k77_1.s2();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.k77_1.u2(i) === $this.k77_1.u2(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.k77_1.u2(i) === $this.k77_1.u2(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function *advanceToNextPotentialMatch($this, $completion) {
  while (!$this.n77_1.g72() || (yield* $this.j77_1.e77(VOID, $completion))) {
    var nextMatch = indexOf($this.n77_1, $this.k77_1.u2(0));
    if (equalsLong(nextMatch, new Long(-1, -1))) {
      var tmp = $this.n77_1;
      checkBounds($this, (tmp instanceof Buffer ? tmp : THROW_CCE()).s2());
      $this.q77_1 = add($this.q77_1, $this.n77_1.j73($this.l77_1.t76()));
      yield* flushIfNeeded($this.l77_1, $completion);
    } else {
      checkBounds($this, nextMatch);
      var tmp_0 = $this;
      var tmp_1 = $this.q77_1;
      var tmp_2 = $this.l77_1.t76();
      tmp_0.q77_1 = add(tmp_1, $this.n77_1.g73(tmp_2 instanceof Buffer ? tmp_2 : THROW_CCE(), nextMatch));
      yield* flushIfNeeded($this.l77_1, $completion);
      return Unit_instance;
    }
  }
  return Unit_instance;
}
function *checkFullMatch($this, $completion) {
  while (!$this.n77_1.g72() || (yield* $this.j77_1.e77(VOID, $completion))) {
    var byte = $this.n77_1.j72();
    if ($this.r77_1 > 0 && !(byte === $this.k77_1.u2($this.r77_1))) {
      var oldMatchIndex = $this.r77_1;
      while ($this.r77_1 > 0 && !(byte === $this.k77_1.u2($this.r77_1))) {
        $this.r77_1 = $this.o77_1[$this.r77_1 - 1 | 0];
      }
      var retained = fromInt(oldMatchIndex - $this.r77_1 | 0);
      checkBounds($this, retained);
      var tmp = $this;
      var tmp_0 = $this.q77_1;
      var tmp_1 = $this.l77_1.t76();
      tmp.q77_1 = add(tmp_0, $this.p77_1.g73(tmp_1 instanceof Buffer ? tmp_1 : THROW_CCE(), retained));
      if ($this.r77_1 === 0 && !(byte === $this.k77_1.u2($this.r77_1))) {
        yield* writeByte($this.l77_1, byte, $completion);
        var _unary__edvuaz = $this.q77_1;
        $this.q77_1 = add(_unary__edvuaz, get_ONE());
        return false;
      }
    }
    $this.r77_1 = $this.r77_1 + 1 | 0;
    if ($this.r77_1 === $this.k77_1.s2()) {
      return true;
    }
    $this.p77_1.y73(byte);
  }
  return false;
}
function checkBounds($this, extra) {
  if (compare(add($this.q77_1, extra), $this.m77_1) > 0) {
    throw IOException.i75('Limit of ' + $this.m77_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.k77_1) + '"'));
  }
}
function toSingleLineString($this, $receiver) {
  return replace(decodeToString_0($receiver), '\n', '\\n');
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function cancel_0(_this__u8e3s4) {
  _this__u8e3s4.i77(IOException.i75('Channel was cancelled'));
}
function *readRemaining(_this__u8e3s4, $completion) {
  var result = BytePacketBuilder();
  while (!_this__u8e3s4.x76()) {
    result.x73(_this__u8e3s4.q76());
    yield* _this__u8e3s4.e77(VOID, $completion);
  }
  rethrowCloseCauseIfNeeded_0(_this__u8e3s4);
  return result.f72();
}
function *toByteArray(_this__u8e3s4, $completion) {
  return readBytes(yield* readBuffer(_this__u8e3s4, $completion));
}
function *copyTo(_this__u8e3s4, channel, limit, $completion) {
  var remaining = limit;
  try {
    while (!_this__u8e3s4.x76() && compare(remaining, new Long(0, 0)) > 0) {
      if (_this__u8e3s4.q76().g72()) {
        yield* _this__u8e3s4.e77(VOID, $completion);
      }
      var tmp0 = remaining;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = get_remaining(_this__u8e3s4.q76());
      var count = compare(tmp0, b) <= 0 ? tmp0 : b;
      _this__u8e3s4.q76().i73(channel.t76(), count);
      remaining = subtract(remaining, count);
      yield* channel.f77($completion);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      _this__u8e3s4.i77(cause);
      close_0(channel, cause);
      throw cause;
    } else {
      throw $p;
    }
  }
  finally {
    yield* channel.f77($completion);
  }
  return subtract(limit, remaining);
}
function *discard(_this__u8e3s4, max, $completion) {
  max = max === VOID ? new Long(-1, 2147483647) : max;
  var remaining = max;
  while (compare(remaining, new Long(0, 0)) > 0 && !_this__u8e3s4.x76()) {
    if (get_availableForRead(_this__u8e3s4) === 0) {
      yield* _this__u8e3s4.e77(VOID, $completion);
    }
    var tmp0 = remaining;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(_this__u8e3s4.q76());
    var count = compare(tmp0, b) <= 0 ? tmp0 : b;
    discard_0(_this__u8e3s4.q76(), count);
    remaining = subtract(remaining, count);
  }
  return subtract(max, remaining);
}
function *readAvailable(_this__u8e3s4, buffer, offset, length, $completion) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  if (_this__u8e3s4.x76())
    return -1;
  if (_this__u8e3s4.q76().g72()) {
    yield* _this__u8e3s4.e77(VOID, $completion);
  }
  if (_this__u8e3s4.x76())
    return -1;
  return readAvailable_0(_this__u8e3s4.q76(), buffer, offset, length);
}
function *skipIfFound(_this__u8e3s4, byteString, $completion) {
  if (equals(yield* peek(_this__u8e3s4, byteString.s2(), $completion), byteString)) {
    yield* /*#__NOINLINE__*/discard(_this__u8e3s4, fromInt(byteString.s2()), $completion);
    return true;
  }
  return false;
}
function *readPacket(_this__u8e3s4, packet, $completion) {
  var result = new Buffer();
  $l$loop: while (compare(result.s2(), fromInt(packet)) < 0) {
    if (_this__u8e3s4.q76().g72()) {
      yield* _this__u8e3s4.e77(VOID, $completion);
    }
    if (_this__u8e3s4.x76())
      break $l$loop;
    if (compare(get_remaining(_this__u8e3s4.q76()), subtract(numberToLong(packet), result.s2())) > 0) {
      _this__u8e3s4.q76().i73(result, subtract(numberToLong(packet), result.s2()));
    } else {
      _this__u8e3s4.q76().j73(result);
    }
  }
  if (compare(result.s2(), fromInt(packet)) < 0) {
    throw EOFException.e72('Not enough data available, required ' + packet + ' bytes but only ' + result.s2().toString() + ' available');
  }
  return result;
}
function *readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
  limit = limit === VOID ? new Long(-1, 2147483647) : limit;
  ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
  return yield* (new ByteChannelScanner(_this__u8e3s4, matchString, writeChannel, limit)).s77(ignoreMissing, $completion);
}
function *readLineStrictTo(_this__u8e3s4, out, limit, lineEnding, $completion) {
  limit = limit === VOID ? new Long(-1, 2147483647) : limit;
  lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
  // Inline function 'kotlin.require' call
  if (!(compare(limit, new Long(0, 0)) >= 0)) {
    var message = 'Limit (' + limit.toString() + ') should be non-negative';
    throw IllegalArgumentException.h2(toString_1(message));
  }
  return yield* internalReadLineTo(_this__u8e3s4, out, limit, lineEnding.equals(LineEnding_Lenient_getInstance()), true, $completion);
}
function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.v76();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.v76();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function *readBuffer(_this__u8e3s4, $completion) {
  var result = new Buffer();
  while (!_this__u8e3s4.x76()) {
    result.x73(_this__u8e3s4.q76());
    yield* _this__u8e3s4.e77(VOID, $completion);
  }
  var tmp0_safe_receiver = _this__u8e3s4.v76();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
  return result;
}
function get_availableForRead(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.q76().f72().s2());
}
function *peek(_this__u8e3s4, count, $completion) {
  if (_this__u8e3s4.x76())
    return null;
  if (!(yield* _this__u8e3s4.y76(count, $completion)))
    return null;
  return readByteString(_this__u8e3s4.q76().k73(), count);
}
function *internalReadLineTo(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion) {
  var readBuffer = _this__u8e3s4.q76();
  if (readBuffer.g72()) {
    yield* _this__u8e3s4.e77(VOID, $completion);
  }
  if (_this__u8e3s4.x76())
    return new Long(-1, -1);
  var consumed = {_v: new Long(0, 0)};
  $l$loop: while (compare(consumed._v, limit) < 0 && !_this__u8e3s4.x76()) {
    var limitLeft = subtract(limit, consumed._v);
    var lfIndex = indexOf(readBuffer, 10, VOID, limitLeft);
    var crIndex = internalReadLineTo$scanForSoleCr(readBuffer, lenientLineEnding, lfIndex, limitLeft);
    if (compare(crIndex, new Long(0, 0)) >= 0) {
      internalReadLineTo$transferString(readBuffer, out, consumed, crIndex);
      discard_0(readBuffer, new Long(1, 0));
      return consumed._v;
    }
    if (equalsLong(lfIndex, new Long(0, 0))) {
      discard_0(readBuffer, new Long(1, 0));
      return consumed._v;
    }
    if (compare(lfIndex, new Long(0, 0)) > 0) {
      var tmp;
      var tmp_0 = readBuffer.f72();
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$0 = subtract(lfIndex, fromInt(1));
      if (tmp_0.b73(tmp$ret$0) === 13) {
        tmp = new Long(1, 0);
      } else {
        tmp = new Long(0, 0);
      }
      var isCrlf = tmp;
      internalReadLineTo$transferString(readBuffer, out, consumed, subtract(lfIndex, isCrlf));
      discard_0(readBuffer, add(numberToLong(1), isCrlf));
      return consumed._v;
    }
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(readBuffer);
    var count = compare(limitLeft, b) <= 0 ? limitLeft : b;
    var tmp_1 = readBuffer.f72();
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$2 = subtract(count, fromInt(1));
    if (tmp_1.b73(tmp$ret$2) === 13) {
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$3 = subtract(count, fromInt(1));
      internalReadLineTo$transferString(readBuffer, out, consumed, tmp$ret$3);
      if (yield* internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion))
        return consumed._v;
      internalReadLineTo$transferString(readBuffer, out, consumed, new Long(1, 0));
    } else {
      internalReadLineTo$transferString(readBuffer, out, consumed, count);
    }
    if (compare(consumed._v, limit) < 0 && equalsLong(get_remaining(readBuffer), new Long(0, 0)) && !(yield* _this__u8e3s4.e77(VOID, $completion)))
      break $l$loop;
  }
  if (equalsLong(consumed._v, new Long(0, 0)) && _this__u8e3s4.x76())
    return new Long(-1, -1);
  // Inline function 'kotlin.check' call
  if (!(compare(consumed._v, limit) <= 0)) {
    var message = 'Consumed bytes exceed the limit: ' + consumed._v.toString() + ' > ' + limit.toString() + ". It's an implementation bug, please report it.";
    throw IllegalStateException.o(toString_1(message));
  }
  if (equalsLong(consumed._v, limit)) {
    if (equalsLong(limit, new Long(-1, 2147483647)))
      throw TooLongLineException.a78('Max line length exceeded');
    if (equalsLong(get_remaining(readBuffer), new Long(0, 0)) && !(yield* _this__u8e3s4.e77(VOID, $completion))) {
      throwEndOfStreamException(consumed._v);
    }
    var tmp0_subject = readBuffer.f72().b73(new Long(0, 0));
    if (tmp0_subject === 10) {
      discard_0(readBuffer, new Long(1, 0));
      return consumed._v;
    } else if (tmp0_subject === 13)
      if (yield* internalReadLineTo$discardCrlfOrCr(readBuffer, _this__u8e3s4, lenientLineEnding, $completion))
        return consumed._v;
    throwTooLongLineException(limit);
  }
  if (throwOnIncompleteLine) {
    throwEndOfStreamException(consumed._v);
  }
  return consumed._v;
}
function throwEndOfStreamException(consumed) {
  throw EOFException.e72('Unexpected end of stream after reading ' + consumed.toString() + ' characters');
}
function throwTooLongLineException(limit) {
  throw TooLongLineException.a78('Line exceeds limit of ' + limit.toString() + ' characters');
}
function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.v76();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp0_safe_receiver;
  }
}
function internalReadLineTo$transferString(readBuffer, $out, consumed, count) {
  if (compare(count, new Long(0, 0)) > 0) {
    var string = readString(readBuffer, count);
    $out.o2(string);
    var tmp0 = consumed._v;
    // Inline function 'kotlin.Long.plus' call
    var other = string.length;
    consumed._v = add(tmp0, fromInt(other));
  }
}
function internalReadLineTo$scanForSoleCr(_this__u8e3s4, $lenientLineEnding, lfIndex, limitLeft) {
  if (!$lenientLineEnding)
    return new Long(-1, -1);
  var tmp;
  if (equalsLong(lfIndex, new Long(-1, -1))) {
    // Inline function 'kotlin.Long.minus' call
    var this_0 = get_remaining(_this__u8e3s4);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = subtract(this_0, fromInt(1));
    tmp = compare(limitLeft, b) <= 0 ? limitLeft : b;
  } else if (equalsLong(lfIndex, new Long(0, 0))) {
    tmp = new Long(0, 0);
  } else {
    // Inline function 'kotlin.Long.minus' call
    tmp = subtract(lfIndex, fromInt(1));
  }
  var endIndex = tmp;
  return indexOf(_this__u8e3s4, 13, VOID, endIndex);
}
function *internalReadLineTo$discardCrlfOrCr(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion) {
  if ((compare(get_remaining(_this__u8e3s4), new Long(2, 0)) >= 0 || (yield* $this_internalReadLineTo.y76(2, $completion))) && _this__u8e3s4.f72().b73(new Long(1, 0)) === 10) {
    discard_0(_this__u8e3s4, new Long(2, 0));
    return true;
  }
  if ($lenientLineEnding) {
    discard_0(_this__u8e3s4, new Long(1, 0));
    return true;
  }
  return false;
}
function *flushIfNeeded(_this__u8e3s4, $completion) {
  rethrowCloseCauseIfNeeded_1(_this__u8e3s4);
  if (_this__u8e3s4.p76() || get_size(_this__u8e3s4.t76()) >= 1048576)
    yield* _this__u8e3s4.f77($completion);
  return Unit_instance;
}
function ByteWriteChannel$flushAndClose$ref(p0) {
  return constructCallableReference(function *($completion) {
    return yield* p0.h77($completion);
  }, 0, 1, 21, 'flushAndClose', [p0]);
}
function get_NO_CALLBACK() {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return NO_CALLBACK;
}
var NO_CALLBACK;
function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
  autoFlush = autoFlush === VOID ? false : autoFlush;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return writer_0(_this__u8e3s4, coroutineContext, new ByteChannel(), block);
}
function invokeOnCompletion(_this__u8e3s4, block) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  return _this__u8e3s4.g1p().g1n(block);
}
function *writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? value.length : endIndex;
  _this__u8e3s4.t76().p73(value, startIndex, endIndex);
  yield* flushIfNeeded(_this__u8e3s4, $completion);
  return Unit_instance;
}
function close_0(_this__u8e3s4, cause) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  if (cause == null) {
    fireAndForget(ByteWriteChannel$flushAndClose$ref(_this__u8e3s4));
  } else {
    _this__u8e3s4.i77(cause);
  }
}
function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
  coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  // Inline function 'kotlin.apply' call
  var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda(block, channel));
  this_0.g1n(writer$lambda(channel));
  var job = this_0;
  return new WriterJob(channel, job);
}
function fireAndForget(_this__u8e3s4) {
  _init_properties_ByteWriteChannelOperations_kt__i7slrs();
  startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
}
function *writeByte(_this__u8e3s4, value, $completion) {
  _this__u8e3s4.t76().y73(value);
  yield* flushIfNeeded(_this__u8e3s4, $completion);
  return Unit_instance;
}
function writer$slambda($block, $channel) {
  return constructCallableReference(function *($this$launch, $completion) {
    var nested = Job(get_job($this$launch.d1m()));
    var tmp;
    try {
      yield* $block(new WriterScope($channel, $this$launch.d1m().ep(nested)), $completion);
      nested.o1t();
      var tmp_0;
      if (get_job($this$launch.d1m()).a1n()) {
        $channel.i77(get_job($this$launch.d1m()).d1n());
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var cause = $p;
        cancel(nested, 'Exception thrown while writing to channel', cause);
        $channel.i77(cause);
        tmp_1 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    finally {
      yield* nested.k1n($completion);
      // Inline function 'kotlin.runCatching' call
      var tmp_2;
      try {
        yield* $channel.h77($completion);
        // Inline function 'kotlin.Companion.success' call
        tmp_2 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p_0) {
        var tmp_3;
        if ($p_0 instanceof Error) {
          var e = $p_0;
          // Inline function 'kotlin.Companion.failure' call
          tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p_0;
        }
        tmp_2 = tmp_3;
      }
    }
    return Unit_instance;
  }, 1);
}
function writer$lambda($channel) {
  return (it) => {
    var tmp;
    if (!(it == null) && !$channel.u76()) {
      $channel.i77(it);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
  if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
    properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
    NO_CALLBACK = new NO_CALLBACK$1();
  }
}
function get_CLOSED() {
  _init_properties_CloseToken_kt__9ucr41();
  return CLOSED;
}
var CLOSED;
function ClosedByteChannelException$_init_$ref_yjp351() {
  return constructCallableReference((p0) => ClosedByteChannelException.j78(p0), 1, 0, 22, '<init>');
}
var properties_initialized_CloseToken_kt_lgg8zn;
function _init_properties_CloseToken_kt__9ucr41() {
  if (!properties_initialized_CloseToken_kt_lgg8zn) {
    properties_initialized_CloseToken_kt_lgg8zn = true;
    CLOSED = new CloseToken(null);
  }
}
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.m78_1.x73($this.l78_1.q76());
  $this.n78_1 = add($this.n78_1, appended);
}
function updateConsumed($this) {
  $this.o78_1 = add($this.o78_1, subtract($this.n78_1, $this.m78_1.s2()));
  $this.n78_1 = $this.m78_1.s2();
}
function counted(_this__u8e3s4) {
  return new CountedByteReadChannel(_this__u8e3s4);
}
function readText(_this__u8e3s4) {
  return readString_0(_this__u8e3s4);
}
var LineEnding_Default_instance;
var LineEnding_Lenient_instance;
var LineEnding_entriesInitialized;
function LineEnding_initEntries() {
  if (LineEnding_entriesInitialized)
    return Unit_instance;
  LineEnding_entriesInitialized = true;
  LineEnding_Default_instance = new LineEnding('Default', 0);
  LineEnding_Lenient_instance = new LineEnding('Lenient', 1);
}
function LineEnding_Default_getInstance() {
  LineEnding_initEntries();
  return LineEnding_Default_instance;
}
function LineEnding_Lenient_getInstance() {
  LineEnding_initEntries();
  return LineEnding_Lenient_instance;
}
function _LineEndingMode___init__impl__jo5bul(mode) {
  return mode;
}
function _get_mode__dah3bc($this) {
  return $this;
}
function LineEndingMode__contains_impl_q5pr68($this, other) {
  return (_get_mode__dah3bc($this) | _get_mode__dah3bc(other)) === _get_mode__dah3bc($this);
}
function LineEndingMode__plus_impl_ttpz2j($this, other) {
  return _LineEndingMode___init__impl__jo5bul(_get_mode__dah3bc($this) | _get_mode__dah3bc(other));
}
function LineEndingMode__toString_impl_j4h76r($this) {
  var tmp;
  if ($this === Companion_getInstance_1().q78_1) {
    tmp = 'CR';
  } else if ($this === Companion_getInstance_1().r78_1) {
    tmp = 'LF';
  } else if ($this === Companion_getInstance_1().s78_1) {
    tmp = 'CRLF';
  } else {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = Companion_getInstance_1().u78_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.v78_1;
      if (LineEndingMode__contains_impl_q5pr68($this, it)) {
        destination.d2(element);
      }
    }
    tmp = toString_1(destination);
  }
  return tmp;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
function LineEndingMode__hashCode_impl_2mopm4($this) {
  return $this;
}
function LineEndingMode__equals_impl_qyr4nk($this, other) {
  if (!(other instanceof LineEndingMode))
    return false;
  if (!($this === other.v78_1))
    return false;
  return true;
}
function decode(_this__u8e3s4, input, max) {
  max = max === VOID ? 2147483647 : max;
  var tmp0 = fromInt(max);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = input.f72().s2();
  var tmp$ret$0 = compare(tmp0, b) <= 0 ? tmp0 : b;
  // Inline function 'kotlin.text.buildString' call
  var capacity = convertToInt(tmp$ret$0);
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.ad(capacity);
  decode_0(_this__u8e3s4, input, this_0, max);
  return this_0.toString();
}
function encode(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
  return builder;
}
function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
  var start = fromIndex;
  if (start >= toIndex)
    return Unit_instance;
  $l$loop: while (true) {
    var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, destination);
    // Inline function 'kotlin.check' call
    if (!(rc >= 0)) {
      throw IllegalStateException.o('Check failed.');
    }
    start = start + rc | 0;
    if (start >= toIndex)
      break $l$loop;
  }
}
function canRead(_this__u8e3s4) {
  return !_this__u8e3s4.g72();
}
function readBytes(_this__u8e3s4, count) {
  count = count === VOID ? convertToInt(_this__u8e3s4.s2()) : count;
  return readByteArray(_this__u8e3s4, count);
}
function writeFully_0(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  _this__u8e3s4.p73(buffer, offset, offset + length | 0);
}
function BytePacketBuilder() {
  return new Buffer();
}
function build(_this__u8e3s4) {
  return _this__u8e3s4.f72();
}
function get_size(_this__u8e3s4) {
  return convertToInt(_this__u8e3s4.f72().s2());
}
var ByteReadPacketEmpty;
function get_remaining(_this__u8e3s4) {
  _init_properties_ByteReadPacket_kt__28475y();
  return _this__u8e3s4.f72().s2();
}
function takeWhile(_this__u8e3s4, block) {
  _init_properties_ByteReadPacket_kt__28475y();
  while (!_this__u8e3s4.g72() && block(_this__u8e3s4.f72())) {
  }
}
function discard_0(_this__u8e3s4, count) {
  count = count === VOID ? new Long(-1, 2147483647) : count;
  _init_properties_ByteReadPacket_kt__28475y();
  _this__u8e3s4.i72(count);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = get_remaining(_this__u8e3s4);
  var countToDiscard = compare(count, b) <= 0 ? count : b;
  _this__u8e3s4.f72().d73(countToDiscard);
  return countToDiscard;
}
var properties_initialized_ByteReadPacket_kt_hw4st4;
function _init_properties_ByteReadPacket_kt__28475y() {
  if (!properties_initialized_ByteReadPacket_kt_hw4st4) {
    properties_initialized_ByteReadPacket_kt_hw4st4 = true;
    ByteReadPacketEmpty = new Buffer();
  }
}
function readAvailable_0(_this__u8e3s4, buffer, offset, length) {
  offset = offset === VOID ? 0 : offset;
  length = length === VOID ? buffer.length - offset | 0 : length;
  var result = _this__u8e3s4.e73(buffer, offset, offset + length | 0);
  return result === -1 ? 0 : result;
}
function readText_0(_this__u8e3s4, charset, max) {
  charset = charset === VOID ? Charsets_getInstance().c79_1 : charset;
  max = max === VOID ? 2147483647 : max;
  if (charset.equals(Charsets_getInstance().c79_1)) {
    if (max === 2147483647)
      return readString_0(_this__u8e3s4);
    var tmp0 = _this__u8e3s4.f72().s2();
    // Inline function 'kotlin.math.min' call
    var b = fromInt(max);
    var count = compare(tmp0, b) <= 0 ? tmp0 : b;
    return readString(_this__u8e3s4, count);
  }
  return decode(charset.f79(), _this__u8e3s4, max);
}
function toByteArray_0(_this__u8e3s4, charset) {
  charset = charset === VOID ? Charsets_getInstance().c79_1 : charset;
  if (charset.equals(Charsets_getInstance().c79_1))
    return encodeToByteArray(_this__u8e3s4, VOID, VOID, true);
  return encodeToByteArray_0(charset.g79(), _this__u8e3s4, 0, _this__u8e3s4.length);
}
function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
  charset = charset === VOID ? Charsets_getInstance().c79_1 : charset;
  if (charset === Charsets_getInstance().c79_1) {
    return writeString(_this__u8e3s4, toString_1(text), fromIndex, toIndex);
  }
  encodeToImpl(charset.g79(), _this__u8e3s4, text, fromIndex, toIndex);
}
function get_ByteArrayPool() {
  _init_properties_ByteArrayPool_kt__kfi3uj();
  return ByteArrayPool;
}
var ByteArrayPool;
var properties_initialized_ByteArrayPool_kt_td6pfh;
function _init_properties_ByteArrayPool_kt__kfi3uj() {
  if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
    properties_initialized_ByteArrayPool_kt_td6pfh = true;
    ByteArrayPool = new ByteArrayPool$1();
  }
}
var Companion_instance_3;
function Companion_getInstance_2() {
  return Companion_instance_3;
}
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.e79_1;
}
var Charsets_instance;
function Charsets_getInstance() {
  if (Charsets_instance === VOID)
    new Charsets();
  return Charsets_instance;
}
function forName(_this__u8e3s4, name) {
  return Companion_instance_3.t79(name);
}
function decode_0(_this__u8e3s4, input, dst, max) {
  var decoder = Decoder(get_name(get_charset(_this__u8e3s4)), true);
  var tmp0 = input.f72().s2();
  // Inline function 'kotlin.comparisons.minOf' call
  var b = fromInt(max);
  var count = compare(tmp0, b) <= 0 ? tmp0 : b;
  var array = readByteArray(input, convertToInt(count));
  var tmp;
  try {
    // Inline function 'org.khronos.webgl.toInt8Array' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = decoder.w79(array);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      var tmp0_elvis_lhs = cause.message;
      throw MalformedInputException.b79('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
  var result = tmp;
  dst.o2(result);
  return result.length;
}
function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(fromIndex <= toIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException.h2(toString_1(message));
  }
  if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().d79_1)) {
    return encodeISO88591(input, fromIndex, toIndex, dst);
  }
  // Inline function 'kotlin.require' call
  if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().c79_1)) {
    var message_0 = 'Only UTF-8 encoding is supported in JS';
    throw IllegalArgumentException.h2(toString_1(message_0));
  }
  var encoder = new TextEncoder();
  // Inline function 'kotlin.text.substring' call
  var tmp$ret$5 = toString_1(charSequenceSubSequence(input, fromIndex, toIndex));
  var result = encoder.encode(tmp$ret$5);
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  dst.s73(result);
  return result.length;
}
function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
}
function get_charset(_this__u8e3s4) {
  return _this__u8e3s4.u79_1;
}
function get_charset_0(_this__u8e3s4) {
  return _this__u8e3s4.v79_1;
}
function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
  var start = fromIndex;
  if (start >= toIndex)
    return new Int8Array(0);
  var dst = new Buffer();
  var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
  start = start + rc | 0;
  if (start === toIndex) {
    return readByteArray_0(dst);
  }
  encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
  return readByteArray_0(dst);
}
function Decoder(encoding, fatal) {
  fatal = fatal === VOID ? true : fatal;
  var tmp;
  try {
    tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var cause = $p;
      tmp_0 = new TextDecoderFallback(encoding, fatal);
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function toKtor(_this__u8e3s4) {
  return new toKtor$1(_this__u8e3s4);
}
function textDecoderOptions(fatal) {
  fatal = fatal === VOID ? false : fatal;
  // Inline function 'kotlin.apply' call
  var this_0 = new Object();
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.with' call
  this_0.fatal = fatal;
  return this_0;
}
function get_ENCODING_ALIASES() {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return ENCODING_ALIASES;
}
var ENCODING_ALIASES;
function get_REPLACEMENT() {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return REPLACEMENT;
}
var REPLACEMENT;
function toCodePoint(_this__u8e3s4) {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  var value = _this__u8e3s4 & 255;
  if (isASCII(value)) {
    return value;
  }
  return get_WIN1252_TABLE()[value - 128 | 0];
}
function isASCII(_this__u8e3s4) {
  _init_properties_TextDecoderFallback_js_kt__an7r6m();
  return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
}
var properties_initialized_TextDecoderFallback_js_kt_6rekzk;
function _init_properties_TextDecoderFallback_js_kt__an7r6m() {
  if (!properties_initialized_TextDecoderFallback_js_kt_6rekzk) {
    properties_initialized_TextDecoderFallback_js_kt_6rekzk = true;
    ENCODING_ALIASES = setOf(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
    // Inline function 'kotlin.byteArrayOf' call
    REPLACEMENT = new Int8Array([-17, -65, -67]);
  }
}
function get_DEVELOPMENT_MODE() {
  return false;
}
function ioDispatcher() {
  return Dispatchers_getInstance().c1u_1;
}
function encodeISO88591(input, fromIndex, toIndex, dst) {
  if (fromIndex >= toIndex)
    return 0;
  var inductionVariable = fromIndex;
  if (inductionVariable < toIndex)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(input, index);
      var character = Char__toInt_impl_vasixd(this_0);
      if (character > 255) {
        failedToMapError(character);
      }
      dst.y73(toByte(character));
    }
     while (inductionVariable < toIndex);
  return toIndex - fromIndex | 0;
}
function failedToMapError(ch) {
  throw MalformedInputException.b79('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
}
function get_WIN1252_TABLE() {
  _init_properties_Win1252Table_kt__tl0v64();
  return WIN1252_TABLE;
}
var WIN1252_TABLE;
var properties_initialized_Win1252Table_kt_pkmjoq;
function _init_properties_Win1252Table_kt__tl0v64() {
  if (!properties_initialized_Win1252Table_kt_pkmjoq) {
    properties_initialized_Win1252Table_kt_pkmjoq = true;
    // Inline function 'kotlin.intArrayOf' call
    WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForObject(Empty, 'Empty');
initMetadataForClass(Closed, 'Closed');
initMetadataForInterface(Task, 'Task');
protoOf(Read).r75 = resume;
protoOf(Read).s75 = resume_0;
initMetadataForClass(Read, 'Read', VOID, VOID, [Task]);
protoOf(Write).r75 = resume;
protoOf(Write).s75 = resume_0;
initMetadataForClass(Write, 'Write', VOID, VOID, [Task]);
initMetadataForInterface(ByteReadChannel, 'ByteReadChannel', VOID, VOID, VOID, [1]);
initMetadataForInterface(ByteWriteChannel, 'ByteWriteChannel', VOID, VOID, VOID, [0]);
protoOf(ByteChannel).e77 = awaitContent$default;
initMetadataForClass(ByteChannel, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel, ByteWriteChannel], [1, 0]);
initMetadataForClass(ConcurrentIOException, 'ConcurrentIOException');
initMetadataForClass(ByteChannelScanner, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
protoOf(ByteReadChannel$Companion$Empty$1).e77 = awaitContent$default;
initMetadataForClass(ByteReadChannel$Companion$Empty$1, VOID, VOID, VOID, [ByteReadChannel], [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(WriterJob, 'WriterJob');
initMetadataForClass(WriterScope, 'WriterScope');
initMetadataForClass(NO_CALLBACK$1, VOID, VOID, VOID, [Continuation]);
initMetadataForClass(CloseToken, 'CloseToken');
protoOf(CountedByteReadChannel).e77 = awaitContent$default;
initMetadataForClass(CountedByteReadChannel, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel], [1]);
initMetadataForClass(ClosedByteChannelException, 'ClosedByteChannelException', ClosedByteChannelException.j78);
initMetadataForClass(ClosedReadChannelException, 'ClosedReadChannelException', ClosedReadChannelException.j76);
initMetadataForClass(ClosedWriteChannelException, 'ClosedWriteChannelException', ClosedWriteChannelException.o76);
initMetadataForClass(LineEnding, 'LineEnding');
initMetadataForCompanion(Companion_1);
initMetadataForClass(LineEndingMode, 'LineEndingMode');
protoOf(SourceByteReadChannel).e77 = awaitContent$default;
initMetadataForClass(SourceByteReadChannel, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel], [1]);
initMetadataForClass(MalformedInputException, 'MalformedInputException');
initMetadataForClass(TooLongLineException, 'TooLongLineException');
initMetadataForInterface(ObjectPool, 'ObjectPool', VOID, VOID, [AutoCloseable]);
protoOf(DefaultPool).f7 = close;
initMetadataForClass(DefaultPool, 'DefaultPool', VOID, VOID, [ObjectPool]);
initMetadataForClass(ByteArrayPool$1);
protoOf(NoPoolImpl).f7 = close;
initMetadataForClass(NoPoolImpl, 'NoPoolImpl', VOID, VOID, [ObjectPool]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(Charset, 'Charset');
initMetadataForObject(Charsets, 'Charsets');
initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
initMetadataForClass(CharsetImpl, 'CharsetImpl');
initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl');
initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl');
initMetadataForClass(toKtor$1);
initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
//endregion
//region block: init
Empty_instance = new Empty();
Companion_instance_3 = new Companion_2();
//endregion
//region block: exports
export {
  LineEndingMode__plus_impl_ttpz2j as LineEndingMode__plus_impl_ttpz2j3u2ebrlepd29o,
  Charsets_getInstance as Charsets_getInstance3jooo7e4x0j2x,
  Companion_getInstance_0 as Companion_getInstance25751un9ltd4f,
  Companion_getInstance_1 as Companion_getInstance33j3lym6q7yx7,
  copyTo as copyTo1e8cxw3cmqjst,
  readAvailable as readAvailable2yaaricqompas,
  readLineStrictTo as readLineStrictTo30g42df56og5l,
  readPacket as readPacket25aqlhslm04t6,
  readRemaining as readRemaining1kbpbgdrq25q1,
  readUntil as readUntil13nwpwqdlw2vo,
  skipIfFound as skipIfFound2z2la3mzzpubl,
  toByteArray as toByteArray1nbmiiav9igm0,
  writeFully as writeFullyuc6cd2hh6ex3,
  MalformedInputException as MalformedInputExceptionbvc6h5ij0ias,
  decode as decode1t43jmuxrxpmo,
  encode as encode35e4rpnc94tb5,
  forName as forName2faodmskqnoz5,
  get_name as get_name2f11g4r0d5pxp,
  BytePacketBuilder as BytePacketBuilder2biodf4wxvlba,
  build as buildjygoh729rhy8,
  canRead as canRead1guo8vbveth0f,
  readText_0 as readText27783kyxjxi1g,
  get_remaining as get_remaining1lapv95kcmm0y,
  get_size as get_size2imoy2jq11jxl,
  takeWhile as takeWhile34751tcfg6owx,
  toByteArray_0 as toByteArray1i3ns5jnoqlv6,
  writeFully_0 as writeFully359t6q8kam2g5,
  writeText as writeText19qfzm98fbm4l,
  get_ByteArrayPool as get_ByteArrayPool3f7yrgvqxz9ct,
  DefaultPool as DefaultPool2gb1fm4epwgu9,
  NoPoolImpl as NoPoolImplgos9n8jphzjp,
  ByteChannel as ByteChannel3cxdguezl3lu7,
  ByteReadChannel_0 as ByteReadChannel1cb89sbyipkce,
  ByteReadChannel as ByteReadChannel2wzou76jce72d,
  ClosedByteChannelException as ClosedByteChannelException3il8gfpye60w,
  cancel_0 as canceldn4b3cdqcfny,
  close_0 as close3semq7pafb42g,
  counted as counted3iniv3aql3f9n,
  invokeOnCompletion as invokeOnCompletion1ziuxzoag0iwj,
  ioDispatcher as ioDispatcher3b9pa3x0duop,
  readText as readText3frapgncbqrcg,
  writer as writer1eia5its2a1fh,
};
//endregion
